import { Navigate, Outlet, useSearchParams } from "react-router-dom";

import { useGetCurrentUser } from "~/api/users/users";
import { AuthHeader } from "../AuthHeader";
import ErrorBoundaryWrapper from "../ErrorBoundaryWrapper";

export const AuthLayout = () => {
  const { data: userInfo } = useGetCurrentUser();
  const [searchParams] = useSearchParams();

  if (userInfo) {
    const retpath = searchParams.get("retpath");
    const to = retpath ? decodeURIComponent(retpath) : "/";
    return <Navigate to={to} replace />;
  }

  return (
    <ErrorBoundaryWrapper>
      <div className="min-h-screen">
        <div className="max-w-[1920px] mx-auto">
          <AuthHeader />
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </ErrorBoundaryWrapper>
  );
};
